export enum CUSTOMER_QUERY_DATE_RANGE {
  DAY1 = 1,
  DAY7 = 2,
  DAY30 = 3,
  DAY90 = 4,
}

export const customerQueryDateRangeDic = {
  [CUSTOMER_QUERY_DATE_RANGE.DAY1]: 'Last 1 day',
  [CUSTOMER_QUERY_DATE_RANGE.DAY7]: 'Last 7 days',
  [CUSTOMER_QUERY_DATE_RANGE.DAY30]: 'Last 30 days',
  [CUSTOMER_QUERY_DATE_RANGE.DAY90]: 'Last 90 days',
};

export enum CUSTOMER_QUERY_SORT_BY {
  NEWEST = 1,
  HIGHEST_NEGATIVE_COUNT = 2,
  HIGHEST_NEGATIVE_SHARES = 3,
}

export enum CUSTOMER_QUERY_DIRECTION {
  NEXT = 1,
  PREV = 2,
}

export enum CUSTOMER_QUERY_SENTIMENT {
  HAPPY = 1,
  UNHAPPY = 3,
}

export enum CUSTOMER_QUERY_DOMAIN {
  ACCOUNT = 1,
  CONTACT = 2,
}

export const customerQueryDomainDic = {
  [CUSTOMER_QUERY_DOMAIN.ACCOUNT]: 'Account',
  [CUSTOMER_QUERY_DOMAIN.CONTACT]: 'Contact',
};

export enum CUSTOMER_DOMAIN {
  ACCOUNT = 'company',
  CONTACT = 'customer',
}
